import MojitoPresentation from 'mojito/presentation';

const { ImageButton } = MojitoPresentation.Components;

const ShowAllSelectionsButton = ({ mojitoTools, minimized, onMinimizeChange }) => {
    const {
        config: { showAllButton, hideAllButton, showl10nKey, hidel10nKey },
        stringResolver,
    } = mojitoTools;

    return (
        <ImageButton
            config={minimized ? showAllButton : hideAllButton}
            label={stringResolver.resolveString(minimized ? showl10nKey : hidel10nKey)}
            onClick={onMinimizeChange}
        />
    );
};

export default ShowAllSelectionsButton;
